'use client'

import { useParams } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'

import Tab from '@/components/ticketDetail/components/shared/Tab'

type TabBarProps = {
  tabs: { couponSeq: string; couponName: string }[]
  selectedSeq: number
  onClick: (ticketSeq: string) => void
}

const TabBar = ({ tabs, selectedSeq, onClick }: TabBarProps) => {
  const { id } = useParams<{ id: string }>()

  const GAP = 12
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [centerX, setCenterX] = useState(0)
  const [scrollValue, setScrollValue] = useState(0)
  const [currentSeq, setCurrentSeq] = useState('')

  const handleSetTabCenter = (tabCenterX: number, seq: string) => {
    const container = containerRef.current
    if (!container) return

    const newScrollValue = tabCenterX - centerX + container.scrollLeft + GAP / 2

    setScrollValue(newScrollValue)
    onClick(seq)
  }

  useEffect(() => {
    setCurrentSeq(id)
  }, [id])

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    container.scrollLeft = scrollValue
  }, [scrollValue])

  useEffect(() => {
    const updateCenterX = () => {
      const w = window.innerWidth
      setCenterX(w / 2)
    }

    updateCenterX()

    window.addEventListener('resize', updateCenterX)
    return () => window.removeEventListener('resize', updateCenterX)
  }, [])

  return (
    <div ref={containerRef} className={` min-h-[28px] w-screen max-w-[768px] overflow-x-scroll`}>
      <div className={`flex flex-nowrap`}>
        {tabs.map((tab, i) => (
          <Tab
            currentSeq={currentSeq}
            tab={tab.couponName}
            key={i}
            isActive={tab.couponSeq == String(selectedSeq)}
            setTabCenter={(tabCenterX: number) => handleSetTabCenter(tabCenterX, tab.couponSeq)}
          />
        ))}
      </div>
    </div>
  )
}

export default TabBar
